module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Second_criterium-contrast-d7465fb754689b1fbdefc9b2f31dd3fa.svg";